import type { z } from 'zod';
import { zs } from '@/entities/shared/schemas/zod';

export const taskKindSchema = zs.enum(['action', 'recommendation', 'check']);

export type TaskKind = z.infer<typeof taskKindSchema>;
